import {fetch} from '@/utils/fetch';

/**
 *
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getWarnReasonList() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/warnReasons`,
    method: 'get',
  });
}

export function findWarnReason(id) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/warnReasons/${ id }`,
    method: 'get',
  });
}

export function saveWarnReason(warnReason) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/warnReasons`,
    method: 'post',
    data: warnReason,
  });
}

export function updateWarnReason(warnReason) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/warnReasons`,
    method: 'patch',
    data: warnReason,
  });
}

export function delWarnReason(id) {
  return fetch({
    url: `/api/warnReasons/${id}`,
    method: 'delete',
  });
}
export function chaneWarning() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/hock-status-exception`,
    method: 'get'
  })
}
